export default "__VITE_PUBLIC_ASSET__6ead0556__"